/**
 * Teslimat Bilgileri Seçici - Sürüm 3.6
 * Yeni özellik: Default city desteği (İstanbul-Avrupa Yakası)
 * Bugün için son sipariş saati (same_day_cutoff)
 * Tatil günleri format sorunu düzeltildi
 */

class DeliveryInfoSelector {
  constructor(element) {
    this.element = element;
    this.selectedData = {
      city: '',
      district: '',
      neighborhood: '',
      date: '',
      time: '',
      message: ''
    };
    
    this.validationEnabled = this.element.getAttribute('data-validation-enabled') === 'true';
    this.timeSlotsEnabled = this.element.getAttribute('data-time-slots-enabled') === 'true';
    this.cargoEnabled = this.element.getAttribute('data-cargo-enabled') === 'true';
    this.useCartAttributes = this.element.getAttribute('data-use-cart-attributes') === 'true';
    this.defaultCity = this.element.getAttribute('data-default-city') || '';
    
    this.sameDayCutoff = this.parseCutoffTime();
    
    this.slot1Start = this.parseTimeToHour(this.element.getAttribute('data-slot1-start')) || 10;
    this.slot1End = this.parseTimeToHour(this.element.getAttribute('data-slot1-end')) || 14;
    this.slot2Start = this.parseTimeToHour(this.element.getAttribute('data-slot2-start')) || 14;
    this.slot2End = this.parseTimeToHour(this.element.getAttribute('data-slot2-end')) || 18;
    this.slot3Start = this.parseTimeToHour(this.element.getAttribute('data-slot3-start')) || 18;
    this.slot3End = this.parseTimeToHour(this.element.getAttribute('data-slot3-end')) || 22;
    
    this.citiesData = this.parseCitiesData();
    this.neighborhoodsData = this.parseNeighborhoodsData();
    this.holidayDates = this.parseHolidayDates();
    
    this.init();
  }
  
  parseTimeToHour(timeStr) {
    if (!timeStr) return null;
    const parts = timeStr.split(':');
    return parseInt(parts[0]) || null;
  }
  
  parseTimeToHourMinute(timeStr) {
    if (!timeStr) return { hour: 16, minute: 0 };
    const parts = timeStr.split(':');
    return {
      hour: parseInt(parts[0]) || 16,
      minute: parseInt(parts[1]) || 0
    };
  }
  
  parseCutoffTime() {
    const cutoffStr = this.element.getAttribute('data-same-day-cutoff') || '16:00';
    const parsed = this.parseTimeToHourMinute(cutoffStr);
    console.log('⏰ Bugün için son sipariş saati: ' + parsed.hour + ':' + String(parsed.minute).padStart(2, '0'));
    return parsed;
  }
  
  parseHolidayDates() {
    const holidayDatesElement = this.element.querySelector('.delivery-date-grid');
    const holidayDatesString = holidayDatesElement ? holidayDatesElement.getAttribute('data-holiday-dates') : '';
    
    if (!holidayDatesString || holidayDatesString.trim() === '') {
      console.log('📅 Tatil günü tanımlanmamış');
      return [];
    }
    
    const rawDates = holidayDatesString.split(',').map(d => d.trim()).filter(d => d !== '');
    const normalizedDates = [];
    
    rawDates.forEach(dateStr => {
      if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateStr.split('-');
        normalizedDates.push(day + '.' + month + '.' + year);
        console.log('📅 Tatil günü eklendi: ' + dateStr + ' → ' + day + '.' + month + '.' + year);
      } else if (dateStr.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
        normalizedDates.push(dateStr);
        console.log('📅 Tatil günü eklendi: ' + dateStr);
      } else {
        console.warn('⚠️ Geçersiz tatil günü formatı: ' + dateStr);
      }
    });
    
    console.log('📅 Toplam tatil günü sayısı:', normalizedDates.length);
    return normalizedDates;
  }
  
  init() {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('🚀 Teslimat Bilgileri Seçici V3.6 başlatıldı!');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('📦 Cart Attributes kullanımı:', this.useCartAttributes);
    console.log('⏰ Bugün için son sipariş: ' + this.sameDayCutoff.hour + ':' + String(this.sameDayCutoff.minute).padStart(2, '0'));
    console.log('📅 Aynı gün teslimat:', this.canSelectToday() ? 'MÜMKÜN ✅' : 'MÜMKÜN DEĞİL ❌');
    console.log('🚚 Kargo seçeneği:', this.cargoEnabled ? 'AKTİF' : 'PASİF');
    console.log('🎄 Tatil günleri:', this.holidayDates.length > 0 ? this.holidayDates.join(', ') : 'Yok');
    console.log('🏙️ Default şehir:', this.defaultCity || 'Yok');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    
    this.setupTimeSlots();
    this.setupDateGrid();
    this.loadCities();
    this.bindEvents();
    
    // Default city varsa otomatik seç ve ilçeleri yükle
    if (this.defaultCity) {
      this.applyDefaultCity();
    }
    
    if (this.useCartAttributes) {
      this.setupCartAttributesSync();
    }
  }
  
  applyDefaultCity() {
    const cityList = this.element.querySelector('[data-city-list]');
    if (!cityList) return;
    
    // Şehir verisinde default city var mı kontrol et
    if (!this.citiesData[this.defaultCity]) {
      console.warn('⚠️ Default şehir "' + this.defaultCity + '" şehir verisinde bulunamadı!');
      return;
    }
    
    console.log('🏙️ Default şehir uygulanıyor: ' + this.defaultCity);
    
    // 1. selectedData güncelle
    this.selectedData.city = this.defaultCity;
    
    // 2. City dropdown UI güncelle
    const cityDropdown = this.element.querySelector('[data-dropdown="city"]');
    if (cityDropdown) {
      const valueSpan = cityDropdown.querySelector('.delivery-dropdown-value');
      if (valueSpan) {
        valueSpan.textContent = this.defaultCity;
        valueSpan.setAttribute('data-selected', 'true');
      }
      
      // City listesinde ilgili öğeyi selected yap
      const cityItem = cityList.querySelector('[data-value="' + this.defaultCity + '"]');
      if (cityItem) {
        cityItem.classList.add('selected');
      }
    }
    
    // 3. Property input güncelle
    this.updatePropertyInput('city', this.defaultCity);
    
    // 4. İlçe dropdown'unu aktif et ve ilçeleri yükle
    this.loadDistricts(this.defaultCity);
    
    // 5. Button state güncelle
    this.updateButtonState();
    
    console.log('✅ Default şehir başarıyla uygulandı: ' + this.defaultCity);
  }
  
  setupTimeSlots() {
    const timeSlotWrapper = this.element.querySelector('.delivery-time-slot-wrapper');
    if (!timeSlotWrapper) return;
    
    if (!this.cargoEnabled) {
      console.log('🚫 Kargo devre dışı - Grid 3 sütuna ayarlanıyor');
      timeSlotWrapper.setAttribute('data-cargo-disabled', 'true');
      const cargoOption = this.element.querySelector('.delivery-time-slot-cargo');
      if (cargoOption) {
        cargoOption.remove();
        console.log('🗑️ Kargo seçeneği kaldırıldı');
      }
    } else {
      timeSlotWrapper.setAttribute('data-cargo-disabled', 'false');
      console.log('✅ Kargo aktif - Grid 4 sütun');
    }
  }
  
  canSelectToday() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    
    if (currentHour > this.sameDayCutoff.hour) {
      return false;
    }
    if (currentHour === this.sameDayCutoff.hour && currentMinute >= this.sameDayCutoff.minute) {
      return false;
    }
    return true;
  }
  
  getFirstDeliveryDate() {
    const today = new Date();
    
    if (this.canSelectToday()) {
      console.log('✅ Aynı gün teslimat aktif!');
      return today;
    } else {
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      console.log('📅 Son sipariş saati (' + this.sameDayCutoff.hour + ':' + String(this.sameDayCutoff.minute).padStart(2, '0') + ') geçti, yarından başlıyor');
      return tomorrow;
    }
  }
  
  isHoliday(dateStr) {
    return this.holidayDates.includes(dateStr);
  }
  
  setupCartAttributesSync() {
    console.log('🔄 Cart Attributes senkronizasyonu kuruldu');
    // Default city zaten set edildiyse, cart attributes'ı da güncelle
    if (this.defaultCity && this.selectedData.city) {
      this.updateCartAttributes();
    } else {
      this.checkExistingCartAttributes();
    }
  }
  
  async checkExistingCartAttributes() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (cart.attributes) {
        console.log('📋 Mevcut Cart Attributes:', cart.attributes);
        if (cart.attributes['Teslimat İli']) {
          this.selectedData.city = cart.attributes['Teslimat İli'];
          const cityButton = this.element.querySelector('[data-dropdown="city"] .delivery-dropdown-value');
          if (cityButton) {
            cityButton.textContent = cart.attributes['Teslimat İli'];
            cityButton.setAttribute('data-selected', 'true');
          }
        }
      }
    } catch (error) {
      console.error('Cart attributes kontrol hatası:', error);
    }
  }
  
  async updateCartAttributes() {
    if (!this.useCartAttributes) return;
    
    const attributes = {
      'Teslimat İli': this.selectedData.city || '',
      'Teslimat İlçesi': this.selectedData.district || '',
      'Teslimat Semti': this.selectedData.neighborhood || '',
      'Teslimat Tarihi': this.selectedData.date || '',
      'Teslimat Saati': this.selectedData.time || '',
      'Pasta Mesajı': this.selectedData.message || ''
    };
    
    const filteredAttributes = {};
    Object.keys(attributes).forEach(key => {
      if (attributes[key]) {
        filteredAttributes[key] = attributes[key];
      }
    });
    
    console.log('📤 Cart Attributes güncelleniyor:', filteredAttributes);
    
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: filteredAttributes })
      });
      
      if (response.ok) {
        console.log('✅ Cart Attributes başarıyla güncellendi');
        Object.keys(filteredAttributes).forEach(key => {
          const input = this.element.querySelector('input[name="attributes[' + key + ']"]');
          if (input) input.value = filteredAttributes[key];
        });
      }
    } catch (error) {
      console.error('❌ Cart Attributes güncelleme hatası:', error);
    }
  }
  
  parseCitiesData() {
    try {
      const dataStr = this.element.getAttribute('data-cities');
      if (!dataStr || dataStr === '') return {};
      const parsed = JSON.parse(dataStr);
      console.log('📍 Şehir verisi yüklendi:', Object.keys(parsed).length, 'şehir');
      return parsed;
    } catch (error) {
      console.error('Şehir verisi parse hatası:', error);
      return {};
    }
  }
  
  parseNeighborhoodsData() {
    try {
      const dataStr = this.element.getAttribute('data-neighborhoods');
      if (!dataStr || dataStr === '') return {};
      const parsed = JSON.parse(dataStr);
      console.log('🏘️ Semt verisi yüklendi');
      return parsed;
    } catch (error) {
      console.error('Semt verisi parse hatası:', error);
      return {};
    }
  }
  
  setupDateGrid() {
    const dateOptions = this.element.querySelectorAll('.delivery-date-option');
    const firstDeliveryDate = this.getFirstDeliveryDate();
    
    const dayNames = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    const monthNames = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    
    dateOptions.forEach((option, index) => {
      const targetDate = new Date(firstDeliveryDate);
      targetDate.setDate(targetDate.getDate() + index);
      
      const dayElement = option.querySelector('.delivery-date-day');
      const labelElement = option.querySelector('.delivery-date-label');
      
      const dayName = dayNames[targetDate.getDay()];
      const day = targetDate.getDate();
      const month = monthNames[targetDate.getMonth()];
      
      dayElement.textContent = day + ' ' + month;
      
      let label = dayName;
      if (index === 0) {
        label = this.canSelectToday() ? 'Bugün' : 'Yarın';
      } else if (index === 1 && this.canSelectToday()) {
        label = 'Yarın';
      }
      labelElement.textContent = label;
      
      const dateStr = this.formatDate(targetDate);
      option.setAttribute('data-date', dateStr);
      
      if (this.isHoliday(dateStr)) {
        option.classList.add('disabled');
        option.setAttribute('title', 'Bu tarihte teslimat yapılmamaktadır');
        console.log('🎄 Tatil günü engellendi: ' + dateStr);
      }
    });
    
    this.updateInitialTimeSlots();
  }
  
  updateInitialTimeSlots() {
    if (this.canSelectToday()) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      
      console.log('⏰ Mevcut saat:', currentHour + ':' + String(currentMinute).padStart(2, '0'));
      console.log('📦 Slot durumları kontrol ediliyor...');
      
      const timeSlots = this.element.querySelectorAll('.delivery-time-slot-option:not(.delivery-time-slot-cargo)');
      
      timeSlots.forEach(slot => {
        const slotStart = this.parseTimeToHour(slot.getAttribute('data-slot-start'));
        const slotEnd = this.parseTimeToHour(slot.getAttribute('data-slot-end'));
        
        if (currentHour >= slotStart) {
          console.log('   ⛔ Slot ' + slotStart + ':00-' + slotEnd + ':00 - Geçmiş (disable)');
          slot.classList.add('disabled');
          slot.setAttribute('title', 'Bu saat dilimi için teslimat süresi geçmiştir');
        } else {
          console.log('   ✅ Slot ' + slotStart + ':00-' + slotEnd + ':00 - Uygun');
        }
      });
    }
  }
  
  loadCities() {
    const cityList = this.element.querySelector('[data-city-list]');
    if (!cityList) return;
    
    const cities = Object.keys(this.citiesData).sort();
    cityList.innerHTML = cities.map(city => '<div class="delivery-dropdown-item" data-value="' + city + '">' + city + '</div>').join('');
    console.log('🏙️', cities.length, 'şehir yüklendi');
  }
  
  loadDistricts(city) {
    const districtDropdown = this.element.querySelector('[data-dropdown="district"]');
    if (!districtDropdown) return;
    
    const button = districtDropdown.querySelector('.delivery-dropdown-button');
    const list = districtDropdown.querySelector('[data-district-list]');
    const valueSpan = button.querySelector('.delivery-dropdown-value');
    
    const districts = this.citiesData[city] || [];
    
    if (districts.length > 0) {
      list.innerHTML = districts.map(district => '<div class="delivery-dropdown-item" data-value="' + district + '">' + district + '</div>').join('');
      button.disabled = false;
      valueSpan.textContent = '';
      valueSpan.setAttribute('data-selected', 'false');
      console.log('📍', districts.length, 'ilçe yüklendi:', city);
    }
  }
  
  loadNeighborhoods(district) {
    const neighborhoodDropdown = this.element.querySelector('[data-dropdown="neighborhood"]');
    if (!neighborhoodDropdown) return;
    
    const button = neighborhoodDropdown.querySelector('.delivery-dropdown-button');
    const list = neighborhoodDropdown.querySelector('[data-neighborhood-list]');
    const valueSpan = button.querySelector('.delivery-dropdown-value');
    
    const neighborhoods = this.neighborhoodsData[district] || [];
    
    if (neighborhoods.length > 0) {
      list.innerHTML = neighborhoods.map(n => '<div class="delivery-dropdown-item" data-value="' + n + '">' + n + '</div>').join('');
      button.disabled = false;
      valueSpan.textContent = '';
      valueSpan.setAttribute('data-selected', 'false');
      console.log('🏘️', neighborhoods.length, 'semt yüklendi:', district);
    } else {
      button.disabled = true;
      list.innerHTML = '<div class="delivery-dropdown-empty">Bu ilçe için semt bilgisi bulunmamaktadır</div>';
    }
  }
  
  resetDistrict() {
    const districtDropdown = this.element.querySelector('[data-dropdown="district"]');
    if (!districtDropdown) return;
    
    const button = districtDropdown.querySelector('.delivery-dropdown-button');
    const valueSpan = button.querySelector('.delivery-dropdown-value');
    const list = districtDropdown.querySelector('[data-district-list]');
    
    button.disabled = true;
    valueSpan.textContent = '';
    valueSpan.setAttribute('data-selected', 'false');
    list.innerHTML = '';
    this.selectedData.district = '';
    this.updatePropertyInput('district', '');
  }
  
  resetNeighborhood() {
    const neighborhoodDropdown = this.element.querySelector('[data-dropdown="neighborhood"]');
    if (!neighborhoodDropdown) return;
    
    const button = neighborhoodDropdown.querySelector('.delivery-dropdown-button');
    const valueSpan = button.querySelector('.delivery-dropdown-value');
    const list = neighborhoodDropdown.querySelector('[data-neighborhood-list]');
    
    button.disabled = true;
    valueSpan.textContent = '';
    valueSpan.setAttribute('data-selected', 'false');
    list.innerHTML = '';
    this.selectedData.neighborhood = '';
    this.updatePropertyInput('neighborhood', '');
  }
  
  updatePropertyInput(property, value) {
    const input = this.element.querySelector('[data-property="' + property + '"]');
    if (input) {
      input.value = value;
      console.log('✏️ Property güncellendi - ' + property + ':', value);
    }
    
    if (this.useCartAttributes) {
      const attrInput = this.element.querySelector('[data-attribute="' + property + '"]');
      if (attrInput) {
        attrInput.value = value;
        console.log('✏️ Cart Attribute güncellendi - ' + property + ':', value);
      }
      this.updateCartAttributes();
    }
  }
  
  updateTimeSlotAvailability() {
    if (!this.selectedData.date) return;
    
    const dateParts = this.selectedData.date.split('.');
    const selectedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    
    const isToday = selectedDate.getTime() === today.getTime();
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    
    const timeSlots = this.element.querySelectorAll('.delivery-time-slot-option:not(.delivery-time-slot-cargo)');
    
    console.log('📅 Seçilen tarih:', this.selectedData.date);
    console.log('⏰ Bugün mü?', isToday);
    console.log('🕐 Mevcut saat:', currentHour + ':' + String(currentMinute).padStart(2, '0'));
    
    timeSlots.forEach(slot => {
      const slotStart = this.parseTimeToHour(slot.getAttribute('data-slot-start'));
      const slotEnd = this.parseTimeToHour(slot.getAttribute('data-slot-end'));
      
      slot.classList.remove('disabled');
      slot.removeAttribute('title');
      
      if (isToday && currentHour >= slotStart) {
        slot.classList.add('disabled');
        slot.setAttribute('title', 'Bu saat dilimi için teslimat süresi geçmiştir');
        console.log('   ⛔ Slot ' + slotStart + ':00-' + slotEnd + ':00 disabled');
      } else {
        console.log('   ✅ Slot ' + slotStart + ':00-' + slotEnd + ':00 aktif');
      }
    });
  }
  
  bindEvents() {
    this.bindDropdown('city', (value) => {
      console.log('🏙️ Şehir seçildi:', value);
      if (this.selectedData.city && this.selectedData.city !== value) {
        this.resetDistrict();
        this.resetNeighborhood();
      }
      this.selectedData.city = value;
      this.updatePropertyInput('city', value);
      this.loadDistricts(value);
      this.updateButtonState();
    });
    
    this.bindDropdown('district', (value) => {
      console.log('🏘️ İlçe seçildi:', value);
      if (this.selectedData.district && this.selectedData.district !== value) {
        this.resetNeighborhood();
      }
      this.selectedData.district = value;
      this.updatePropertyInput('district', value);
      this.loadNeighborhoods(value);
      this.updateButtonState();
    });
    
    this.bindDropdown('neighborhood', (value) => {
      console.log('🏡 Semt seçildi:', value);
      this.selectedData.neighborhood = value;
      this.updatePropertyInput('neighborhood', value);
      this.updateButtonState();
    });
    
    const dateOptions = this.element.querySelectorAll('.delivery-date-option');
    dateOptions.forEach(option => {
      option.addEventListener('click', () => {
        if (option.classList.contains('disabled')) return;
        
        dateOptions.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        
        const date = option.getAttribute('data-date');
        this.selectedData.date = date;
        this.updatePropertyInput('date', date);
        this.updateTimeSlotAvailability();
        this.updateButtonState();
        
        const customDateInput = this.element.querySelector('.delivery-custom-date-input');
        if (customDateInput) customDateInput.value = '';
        
        const label = option.querySelector('.delivery-date-label').textContent;
        console.log('📅 Tarih seçildi: ' + date + ' (' + label + ')');
      });
    });
    
    const customDateInput = this.element.querySelector('.delivery-custom-date-input');
    if (customDateInput) {
      const minDate = this.getFirstDeliveryDate();
      customDateInput.min = this.formatDateForInput(minDate);
      
      customDateInput.addEventListener('change', (e) => {
        const selectedDate = e.target.value;
        if (selectedDate) {
          const [year, month, day] = selectedDate.split('-');
          const formattedDate = day + '.' + month + '.' + year;
          
          if (this.isHoliday(formattedDate)) {
            alert('Seçtiğiniz tarih tatil gününe denk gelmektedir. Lütfen başka bir tarih seçin.');
            e.target.value = '';
            return;
          }
          
          const selected = new Date(selectedDate);
          const min = new Date(minDate);
          if (selected < min) {
            alert('Lütfen geçerli bir tarih seçin.');
            e.target.value = '';
            return;
          }
          
          dateOptions.forEach(opt => opt.classList.remove('selected'));
          this.selectedData.date = formattedDate;
          this.updatePropertyInput('date', formattedDate);
          this.updateTimeSlotAvailability();
          this.updateButtonState();
          console.log('📅 Custom tarih seçildi: ' + formattedDate);
        }
      });
    }
    
    this.bindTimeSlotEvents();
    
    const messageInput = this.element.querySelector('.delivery-message-input');
    if (messageInput) {
      const updateCounter = () => {
        const currentLength = messageInput.value.length;
        const counterElement = this.element.querySelector('.current-count');
        if (counterElement) counterElement.textContent = currentLength;
        
        const maxLength = parseInt(messageInput.getAttribute('maxlength') || 35);
        messageInput.classList.toggle('at-limit', currentLength >= maxLength);
        
        this.selectedData.message = messageInput.value;
        this.updatePropertyInput('message', messageInput.value);
      };
      
      messageInput.addEventListener('input', updateCounter);
      messageInput.addEventListener('keyup', updateCounter);
    }
    
    this.bindFormValidation();
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.delivery-dropdown')) {
        this.closeAllDropdowns();
      }
    });
    
    console.log('✅ Event\'ler bağlandı!');
  }
  
  bindTimeSlotEvents() {
    const timeSlotOptions = this.element.querySelectorAll('.delivery-time-slot-option');
    
    const activeSlots = Array.from(timeSlotOptions).filter(slot => {
      if (!this.cargoEnabled && slot.classList.contains('delivery-time-slot-cargo')) return false;
      return true;
    });
    
    console.log('⏰ ' + activeSlots.length + ' saat slotu aktif');
    
    activeSlots.forEach(option => {
      option.addEventListener('click', () => {
        if (option.classList.contains('disabled')) return;
        
        if (!this.selectedData.date) {
          alert('Lütfen önce teslimat tarihini seçin.');
          return;
        }
        
        activeSlots.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        
        const slotType = option.getAttribute('data-time-slot');
        let timeValue = '';
        
        if (slotType === 'cargo') {
          timeValue = 'Kargo';
        } else {
          const slotStart = option.getAttribute('data-slot-start');
          const slotEnd = option.getAttribute('data-slot-end');
          timeValue = slotStart + ' - ' + slotEnd;
        }
        
        this.selectedData.time = timeValue;
        this.updatePropertyInput('time', timeValue);
        this.updateButtonState();
        console.log('⏰ Saat seçildi: ' + timeValue);
      });
    });
  }
  
  bindDropdown(type, onSelect) {
    const dropdown = this.element.querySelector('[data-dropdown="' + type + '"]');
    if (!dropdown) return;
    
    const button = dropdown.querySelector('.delivery-dropdown-button');
    const menu = dropdown.querySelector('.delivery-dropdown-menu');
    const searchInput = dropdown.querySelector('.delivery-search-input');
    const list = dropdown.querySelector('.delivery-dropdown-list');
    const valueSpan = button.querySelector('.delivery-dropdown-value');
    
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      this.closeAllDropdowns();
      
      if (!isExpanded) {
        button.setAttribute('aria-expanded', 'true');
        menu.classList.add('active');
        if (searchInput) {
          searchInput.value = '';
          this.filterDropdownItems(list, '');
          setTimeout(() => searchInput.focus(), 100);
        }
      }
    });
    
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.filterDropdownItems(list, e.target.value);
      });
    }
    
    list.addEventListener('click', (e) => {
      const item = e.target.closest('.delivery-dropdown-item');
      if (!item) return;
      
      const value = item.getAttribute('data-value');
      list.querySelectorAll('.delivery-dropdown-item').forEach(i => i.classList.remove('selected'));
      item.classList.add('selected');
      
      valueSpan.textContent = value;
      valueSpan.setAttribute('data-selected', 'true');
      button.setAttribute('aria-expanded', 'false');
      menu.classList.remove('active');
      
      if (onSelect) onSelect(value, item);
    });
  }
  
  filterDropdownItems(list, query) {
    const items = list.querySelectorAll('.delivery-dropdown-item');
    const searchQuery = query.toLowerCase().trim();
    
    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(searchQuery) ? '' : 'none';
    });
  }
  
  closeAllDropdowns() {
    const dropdowns = this.element.querySelectorAll('.delivery-dropdown');
    dropdowns.forEach(dropdown => {
      const button = dropdown.querySelector('.delivery-dropdown-button');
      const menu = dropdown.querySelector('.delivery-dropdown-menu');
      button.setAttribute('aria-expanded', 'false');
      menu.classList.remove('active');
    });
  }
  
  bindFormValidation() {
    console.log('🔍 Form validation başlatılıyor...');
    
    const formId = this.element.getAttribute('data-product-form-id');
    let productForm = formId ? document.getElementById(formId) : null;
    
    if (!productForm) {
      productForm = this.element.closest('form') || 
                    document.querySelector('form[action*="/cart/add"]') ||
                    document.querySelector('.product-form form') ||
                    document.querySelector('form[data-type="add-to-cart-form"]');
    }
    
    if (!productForm) {
      console.error('❌ Product form bulunamadı!');
      return;
    }
    
    console.log('✅ Product form bulundu');
    
    this.addToCartButtons = productForm.querySelectorAll('[name="add"], button[type="submit"], .single-add-to-cart-button');
    console.log('🛒 Add to cart buttons bulundu:', this.addToCartButtons.length);
    
    this.updateButtonState();
    
    this.element.addEventListener('change', () => {
      this.updateButtonState();
    });
    
    productForm.addEventListener('submit', (e) => {
      console.log('📤 FORM SUBMIT EDİLİYOR!');
      
      if (!this.validateForm()) {
        console.log('❌ Validation başarısız');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      if (this.useCartAttributes) {
        this.updateCartAttributes();
      }
      console.log('✅ Validation başarılı!');
    });
  }
  
  updateButtonState() {
    if (!this.validationEnabled || !this.addToCartButtons) return;
    
    const isValid = this.checkIfValid();
    
    this.addToCartButtons.forEach(button => {
      button.disabled = !isValid;
      button.style.opacity = isValid ? '1' : '0.5';
      button.style.cursor = isValid ? 'pointer' : 'not-allowed';
      if (isValid) {
        button.removeAttribute('title');
      } else {
        button.setAttribute('title', 'Lütfen teslimat bilgilerini doldurunuz');
      }
    });
  }
  
  checkIfValid() {
    const cityDropdown = this.element.querySelector('[data-dropdown="city"]');
    if (cityDropdown && !this.selectedData.city) return false;
    
    const districtDropdown = this.element.querySelector('[data-dropdown="district"]');
    if (districtDropdown && !this.selectedData.district) return false;
    
    const neighborhoodDropdown = this.element.querySelector('[data-dropdown="neighborhood"]');
    if (neighborhoodDropdown && !this.selectedData.neighborhood) return false;
    
    if (!this.selectedData.date) return false;
    
    if ((this.timeSlotsEnabled || this.cargoEnabled) && !this.selectedData.time) return false;
    
    return true;
  }
  
  validateForm() {
    if (!this.validationEnabled) return true;
    
    const errors = [];
    
    const cityDropdown = this.element.querySelector('[data-dropdown="city"]');
    if (cityDropdown && !this.selectedData.city) errors.push('Lütfen teslimat ili seçiniz.');
    
    const districtDropdown = this.element.querySelector('[data-dropdown="district"]');
    if (districtDropdown && !this.selectedData.district) errors.push('Lütfen teslimat ilçesi seçiniz.');
    
    const neighborhoodDropdown = this.element.querySelector('[data-dropdown="neighborhood"]');
    if (neighborhoodDropdown && !this.selectedData.neighborhood) errors.push('Lütfen teslimat semti seçiniz.');
    
    if (!this.selectedData.date) errors.push('Lütfen teslimat tarihi seçiniz.');
    
    if ((this.timeSlotsEnabled || this.cargoEnabled) && !this.selectedData.time) errors.push('Lütfen teslimat saatini seçiniz.');
    
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false;
    }
    return true;
  }
  
  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return day + '.' + month + '.' + year;
  }
  
  formatDateForInput(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDeliveryInfoSelectors);
} else {
  initDeliveryInfoSelectors();
}

function initDeliveryInfoSelectors() {
  const selectors = document.querySelectorAll('.delivery-info-selector-wrapper');
  selectors.forEach(selector => new DeliveryInfoSelector(selector));
}

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const selector = event.target.querySelector('.delivery-info-selector-wrapper');
    if (selector) new DeliveryInfoSelector(selector);
  });
}